import { formatUsage } from '../../utils/helpers/aiSpendFormat';

/**
 * The one place a quantity is printed.
 *
 * There is no "Tokens" column anywhere in this dashboard: four of five
 * providers have none, so such a column would put a blank or a zero next to
 * every video and every second of audio and quietly read as "no usage".
 */
export default function UsageCell({ usage, billingUnit }) {
  const text = formatUsage(usage);
  return (
    <span
      className="text-slate-700 dark:text-slate-200"
      title={billingUnit === 'mixed' ? 'This row spans several billing units' : undefined}
    >
      {text}
    </span>
  );
}
